var render = function render(){var _vm=this,_c=_vm._self._c;return (_vm.menuItem.visible)?_c('v-list-tile',_vm._b({key:_vm.menuItem.id,attrs:{"id":_vm.menuItem.id,"active-class":"red--text text--darken-2"},on:{"click":function($event){_vm.menuItem.onClick ? _vm.menuItem.onClick() : undefined}}},'v-list-tile',_vm.menuItem.href ? {
    ref: 'noopener noreferrer',
    target: '_blank',
    href: _vm.menuItem.href
  } : _vm.menuItem.route ? {
    to: _vm.menuItem.route,
    exact: true
  } : undefined,false),[_c('v-list-tile-action',[_c('v-icon',[_vm._v(_vm._s(_vm.menuItem.icon))])],1),_vm._v(" "),_c('v-list-tile-content',{staticClass:"subheading"},[_c('v-list-tile-title',[_vm._v(_vm._s(_vm.menuItem.title))])],1),_vm._v(" "),(_vm.menuItem.counter > 0)?_c('v-chip',{staticClass:"v-chip--x-small",attrs:{"color":_vm.menuItem.counterClasses}},[_vm._v(_vm._s(_vm.menuItem.counter))]):_vm._e()],1):_vm._e()
}
var staticRenderFns = []

export { render, staticRenderFns }